// パネルのヘッダ。ポップアウト中はドラッグ移動の「取っ手」を兼ねる。
import type { PointerEvent as ReactPointerEvent, ReactNode } from 'react';
import type { PanelMode } from '../types';
import airsIcon from '../assets/airs-icon.png';

interface PanelHeaderProps {
  model: string | null;
  mode: PanelMode;
  isMinimized: boolean;
  onToggleHistory: () => void;
  onNewSession: () => void;
  onTogglePopout: () => void;
  onToggleMinimize: () => void;
  onClose: () => void;
  /** ポップアウト中のみ渡される（ドック中は移動不可）。 */
  onPointerDown?: (e: ReactPointerEvent) => void;
}

/** ヘッダ内の操作ボタン。pointerdown を止めてドラッグの誤発動を防ぐ。 */
function HeaderButton(props: { label: string; onClick: () => void; children: ReactNode }) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      onPointerDown={(e) => e.stopPropagation()}
      aria-label={props.label}
      className="text-gray-300 transition hover:text-white"
    >
      {props.children}
    </button>
  );
}

export function PanelHeader(props: PanelHeaderProps) {
  const { model, mode, isMinimized, onToggleHistory, onNewSession } = props;
  const { onTogglePopout, onToggleMinimize, onClose } = props;
  return (
    <header
      onPointerDown={props.onPointerDown}
      className={`flex touch-none select-none items-center justify-between bg-gray-900 px-4 py-3 text-white ${
        props.onPointerDown ? 'cursor-move' : ''
      }`}
    >
      <span className="flex items-center gap-2">
        <img src={airsIcon} alt="" className="h-5 w-5 rounded-full object-cover" />
        <span className="text-sm font-semibold">AI秘書</span>
        {/* 稼働中のモデルを明示する。AI秘書自身は自分のタグ(e2b/e4b)を知らないため、ここでしか確認できない。 */}
        {model && (
          <span className="font-mono text-xs text-gray-400" title="稼働中のモデル">
            {model}
          </span>
        )}
      </span>
      <span className="flex items-center gap-3">
        <HeaderButton label="履歴" onClick={onToggleHistory}>
          🕒
        </HeaderButton>
        {/* 新規作成は ✎（書き始める）。＋は隣の −/✕ と紛らわしいため不採用 */}
        <HeaderButton label="新しいチャット" onClick={onNewSession}>
          ✎
        </HeaderButton>
        <HeaderButton
          label={mode === 'docked' ? 'ポップアウト' : 'サイドに戻す'}
          onClick={onTogglePopout}
        >
          {mode === 'docked' ? '⧉' : '◧'}
        </HeaderButton>
        <HeaderButton label={isMinimized ? '元に戻す' : '最小化'} onClick={onToggleMinimize}>
          {isMinimized ? '□' : '−'}
        </HeaderButton>
        <HeaderButton label="閉じる" onClick={onClose}>
          ✕
        </HeaderButton>
      </span>
    </header>
  );
}
